import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const ComponentContainer = styled.div`
    background: ${tokens.background.paperElevation2};
    color: ${tokens.text.primary};
    border-radius: 4px;
    box-shadow: ${tokens.elevation['100']};
    flex-basis: 20%;
`;
